/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ThreediModelTask } from "./ThreediModelTask";
import {
  ThreediModelTaskFromJSON,
  ThreediModelTaskFromJSONTyped,
  ThreediModelTaskToJSON,
  ThreediModelTaskToJSONTyped,
} from "./ThreediModelTask";

/**
 *
 * @export
 * @interface PaginatedThreediModelTaskList
 */
export interface PaginatedThreediModelTaskList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<ThreediModelTask>;
}

/**
 * Check if a given object implements the PaginatedThreediModelTaskList interface.
 */
export function instanceOfPaginatedThreediModelTaskList(
  value: object
): value is PaginatedThreediModelTaskList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedThreediModelTaskListFromJSON(json: any): PaginatedThreediModelTaskList {
  return PaginatedThreediModelTaskListFromJSONTyped(json, false);
}

export function PaginatedThreediModelTaskListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedThreediModelTaskList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(ThreediModelTaskFromJSON),
  };
}

export function PaginatedThreediModelTaskListToJSON(json: any): PaginatedThreediModelTaskList {
  return PaginatedThreediModelTaskListToJSONTyped(json, false);
}

export function PaginatedThreediModelTaskListToJSONTyped(
  value?: PaginatedThreediModelTaskList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(ThreediModelTaskToJSON),
  };
}
